import { apiClient } from './client';

export async function fetchSupportedLocales() {
  const { data } = await apiClient.get('/api/localization/locales');
  return data;
}

export async function fetchUserLocale() {
  const { data } = await apiClient.get('/api/auth/locale');
  return data;
}

export async function updateUserLocale(locale) {
  const { data } = await apiClient.post('/api/auth/locale', { locale });
  return data;
}
